import { createContext, useCallback, useContext, useRef, useState } from "react";
import ConfirmModal from "../components/common/ConfirmModal";

const ConfirmContext = createContext(null);

export const ConfirmProvider = ({ children }) => {
   const [options, setOptions] = useState(null);
   const resolverRef = useRef(null);

   // resolve any in-flight confirm() before opening the next one — guards against rapid re-triggers
   const resolve = useCallback((result) => {
      const current = resolverRef.current;
      resolverRef.current = null;
      setOptions(null);
      current?.(result);
   }, []);

   const confirm = useCallback((next) => {
      return new Promise((accept) => {
         if (resolverRef.current) {
            resolverRef.current(false);
         }
         resolverRef.current = accept;
         setOptions(next);
      });
   }, []);

   return (
      <ConfirmContext.Provider value={confirm}>
         {children}
         <ConfirmModal
            options={options}
            onConfirm={() => resolve(true)}
            onCancel={() => resolve(false)}
         />
      </ConfirmContext.Provider>
   );
};

export const useConfirm = () => {
   const confirm = useContext(ConfirmContext);
   if (!confirm) {
      throw new Error("useConfirm must be used inside <ConfirmProvider />");
   }
   return confirm;
};

export default ConfirmContext;
